<template>
  <div>
    <v-toolbar dark color="secondary">
      <v-btn dark icon to="/devices"><v-icon>arrow_back</v-icon></v-btn>
      <v-toolbar-title class="white--text">{{ formTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          dark
          text
          v-if="this.editing"
          @click.native="deleteItem(currentItem._id)"
          ><v-icon>delete</v-icon></v-btn
        >
        <v-btn dark text @click.native="saveItem"><v-icon>save</v-icon></v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card flat style="height: 80vh; overflow-y: scroll;">
      <v-container grid-list-xl>
        <v-layout wrap>
          <v-flex xs12 md6>
            <v-text-field
              v-model="currentItem.name"
              label="Device Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="currentItem.codename"
              label="Codename"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="currentItem.kosherUrl"
              label="Kosher URL"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "DeviceDetail",
  data() {
    return {
      editing: true,
      loading: true,
      headers: [
        { text: "Edit", value: "edit", sortable: false },
        { text: "Device", value: "name" },
        { text: "Codename", value: "codename" },
        { text: "URL", value: "kosherUrl" },
      ],
      items: [],
      currentItem: {
        timestamp: null,
        version: 1,
        name: "",
        codename: "",
        kosherUrl: "",
      },
    };
  },
  computed: {
    formTitle() {
      return !this.editing ? "New Device" : "Edit Device";
    },
  },
  methods: {
    getItems() {
      if (!this.editing) {
        this.currentItem = {
          timestamp: null,
          version: 1,
          name: "",
          codename: "",
          kosherUrl: "",
        };
      } else {
        var link =
          "https://api.safetelecom.net/api/devices/" + this.$route.params.id;
        axios.get(link).then((response) => {
          this.currentItem = response.data;
        });
      }

      this.loading = true;
      axios.get(`https://api.safetelecom.net/api/apps`).then((response) => {
        this.apps = response.data.sort((a, b) => {
          if (a.metadata.name < b.metadata.name) {
            return -1;
          }
          if (a.metadata.name > b.metadata.name) {
            return 1;
          }
          return 0;
        });
        this.loading = false;
      });
    },
    editItem(id) {
      this.editing = true;
      axios
        .get(`https://api.safetelecom.net/api/devices/${id}`)
        .then((response) => {
          this.currentItem = response.data;
        });
      this.dialog = true;
    },
    saveItem() {
      if (this.$route.params.id === "new") {
        axios
          .post(`https://api.safetelecom.net/api/devices`, this.currentItem)
          .then(() => {
            this.$router.push("/devices");
          });
      } else {
        axios
          .put(
            `https://api.safetelecom.net/api/devices/${this.currentItem._id}`,
            this.currentItem
          )
          .then(() => {
            this.$router.push("/devices");
          });
      }
    },
    deleteItem(id) {
      confirm("Are you sure you want to delete this item?") &&
        axios
          .delete(`https://api.safetelecom.net/api/devices/${id}`)
          .then(() => {
            this.$router.push("/devices");
          });
    },
  },
  created() {
    if (this.$route.params.id === "new") {
      this.editing = false;
    }
    this.getItems();
  },
};
</script>
